import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Replace these with your actual Firebase configuration from the Firebase Console
const firebaseConfig = {
  apiKey: "AIzaSyBJFm7A_Aq2A1k2mCj28xSbuIv3gruox5o",
  authDomain: "aditidosi-newsletter.firebaseapp.com",
  projectId: "aditidosi-newsletter",
  storageBucket: "aditidosi-newsletter.firebasestorage.app",
  messagingSenderId: "797494100572",
  appId: "1:797494100572:web:753a16c8047ca3ba825c99"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
